export default {
    isUserAuthenticated: state => state.isAuthenticated,
    getAuthUser: state => state.user,
    getAuthUserSmall: state => {
        return {
            id: state.user._id ? state.user._id : '',
            first_name: state.user.personalInformation ? state.user.personalInformation.firstName : '',
            middle_name: state.user.personalInformation ? state.user.personalInformation.middleName : '',
            last_name: state.user.personalInformation ? state.user.personalInformation.lastName : '',
        };
    },
};
